import { ENDPOINTS, WORKFORCE_API_URL } from "../redux/apiConfig";
import axiosRequest from "../redux/slices/universal/axiosService";

export const getEmployeeName = async (employeeId) => {
  try {
    const filters = {
      uiid: { type: "NONE", value: employeeId },
    };

    // const response = await axios.get(ENDPOINTS.EMPLOYEES.GET_BY_UIID, {
    //   params: {
    //     coll: "Employee",
    //     fil: JSON.stringify(filters),
    //     cache: false,
    //     ret: "firstName lastName",
    //   },
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //     "Content-Type": "application/json",
    //   },
    //   withCredentials: true,
    // });
    const response = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.EMPLOYEES.GET_BY_UIID,
      // url: `${WORKFORCE_API_URL}/userrefs/get`,
      params: {
        coll: "Employee",
        fil: JSON.stringify(filters),
        cache: false,
        ret: "firstName lastName",
      },
    });
    let fullName =
      response?.data?.data?.firstName + " " + response?.data?.data?.lastName;
    return fullName;
  } catch (error) {
    console.error("Error fetching employee name:", error.response || error);
    return "-";
  }
};
